import { PawPrint } from "lucide-react";
import { businessConfig } from "@/config";

/**
 * Renders the brand mark — either a hosted image (when
 * `businessConfig.logoImage` is set) or the default lucide PawPrint icon
 * inside the indigo circle. Used by both the header and footer so the
 * whole site rebrands by editing one config value.
 */
export default function BrandLogo({ size = 44, iconSize = 20, className = "" }) {
  const dimension = `${size}px`;
  if (businessConfig.logoImage) {
    return (
      <span
        className={`brand-logo brand-logo--image ${className}`}
        style={{ width: dimension, height: dimension }}
        aria-hidden
      >
        <img src={businessConfig.logoImage} alt="" loading="lazy" />
      </span>
    );
  }
  return (
    <span
      className={`brand-logo brand-logo--icon ${className}`}
      style={{ width: dimension, height: dimension }}
      aria-hidden
    >
      <PawPrint
        style={{ color: "var(--pp-gold)", width: iconSize, height: iconSize }}
        strokeWidth={2.4}
      />
    </span>
  );
}
